// src/pages/Privacidade.js
import React from 'react';
import './pages.css'; // Reutilizando o estilo

const Privacidade = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <h1>Política de Privacidade – primotradesolutions.com.br</h1>
      <p><strong>Última atualização:</strong> 15 de agosto de 2025</p>

      <h2>1. Nosso Compromisso com a Privacidade</h2>
      <p>A PRIMO TRADE SOLUTIONS LTDA ("PTS", "nós"), respeita sua privacidade e se compromete a proteger seus dados pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD, Lei nº 13.709/2018). Esta política descreve como coletamos, usamos, armazenamos e protegemos os dados dos usuários ("Você") que interagem com nosso site.</p>

      <h2>2. Dados que Coletamos e Suas Finalidades</h2>
      <p>Coletamos o mínimo de informações necessárias para atingir finalidades legítimas, específicas e informadas a você.</p>
      <p><strong>Dados Fornecidos por Você (Formulário de Contato):</strong></p>
      <ul>
        <li><strong>Dados:</strong> Nome, sobrenome, telefone, e-mail, nome da empresa, CNPJ e a mensagem que descreve sua necessidade.</li>
        <li><strong>Finalidade:</strong> Responder às suas solicitações, enviar propostas comerciais e realizar as diligências pré-contratuais necessárias para a prestação de nossos serviços.</li>
        <li><strong>Base Legal (LGPD):</strong> Execução de diligências pré-contratuais a seu pedido e nosso legítimo interesse em responder a contatos comerciais.</li>
      </ul>
      
      <h2>3. Com Quem Compartilhamos Seus Dados</h2>
      <p>Não vendemos ou alugamos seus dados pessoais. O compartilhamento ocorre apenas quando estritamente necessário com provedores de serviços de tecnologia (como hospedagem) que atuam como operadores sob nossas instruções.</p>

      <h2>4. Segurança dos Seus Dados</h2>
      <p>Adotamos medidas de segurança técnicas e administrativas, como controle de acesso e criptografia, para proteger seus dados pessoais contra acessos não autorizados e situações acidentais ou ilícitas.</p>

      <h2>5. Seus Direitos como Titular dos Dados</h2>
      <p>A LGPD garante a você diversos direitos, incluindo: Confirmação da existência de tratamento; Acesso aos seus dados; Correção de dados; Anonimização, bloqueio ou eliminação de dados; e a Revogação do consentimento.</p>
      
      <h2>6. Como Exercer Seus Direitos</h2>
      <p>Para exercer qualquer um dos seus direitos, ou para tirar dúvidas sobre o tratamento de seus dados, entre em contato com nosso Encarregado pela Proteção de Dados (DPO) através do canal oficial:</p>
      <p><strong>E-mail:</strong> ricardo.primo@primotradesolutions.com</p>

      <h2>7. Atualizações desta Política</h2>
      <p>Esta Política pode ser atualizada a qualquer momento. A versão mais recente estará sempre disponível em nosso Site, com a data da última atualização no topo do documento.</p>

      <div style={{ marginTop: '40px' }}>
        <p><strong>Controlador:</strong><br />
        PRIMO TRADE SOLUTIONS LTDA<br />
        CNPJ: 42.419.988/0001-78 (Matriz)<br />
        CNPJ: 42.419.988/0002-59 (Filial)</p>
      </div>
    </div>
  );
};

export default Privacidade;